import { useState } from "react";
import { api, gravarSessao, type Sessao } from "../api.ts";

export function Login({ aoEntrar }: { aoEntrar: (s: Sessao) => void }) {
  const [email, setEmail] = useState("");
  const [senha, setSenha] = useState("");
  const [erro, setErro] = useState("");
  const [ocupado, setOcupado] = useState(false);

  /**
   * O logo aparece quando TERMINA de carregar, não numa contagem fixa.
   *
   * Ele é PNG e chega depois do HTML: uma animação por atraso já teria
   * acabado quando o arquivo enfim chega, e o estalo continuaria. Reagir ao
   * `load` é o que remove o salto de verdade.
   *
   * A checagem no `ref` cobre a imagem já em cache: aí o `load` dispara
   * antes de o React pendurar o manipulador, e sem ela o logo ficaria
   * invisível para sempre.
   */
  const [logoPronto, setLogoPronto] = useState(false);

  async function enviar(e: React.FormEvent) {
    e.preventDefault();
    setErro("");
    setOcupado(true);
    try {
      const s = await api.entrar(email, senha);
      gravarSessao(s);
      aoEntrar(s);
    } catch (x) {
      // A API devolve a mesma mensagem para senha errada e e-mail inexistente,
      // de propósito. Repassar tal como veio mantém isso.
      setErro(x instanceof Error ? x.message : "não foi possível entrar");
    } finally {
      setOcupado(false);
    }
  }

  return (
    <div className="login-tela">
      <form className="login-caixa" onSubmit={enviar}>
        {/* O logo tem chapa clara embutida — o cartão branco do login é
            exatamente onde ele cai bem, sem tratamento nenhum. */}
        <img
          ref={(el) => {
            // Cache: o load já passou antes de o React chegar aqui.
            if (el?.complete && el.naturalWidth > 0) setLogoPronto(true);
          }}
          src="/madesoft-logo.png"
          alt="MadeSoft — sistema gerencial de madeiras"
          className={`login-logo${logoPronto ? " pronto" : ""}`}
          onLoad={() => setLogoPronto(true)}
          // Imagem quebrada não pode deixar a tela pela metade para sempre.
          onError={() => setLogoPronto(true)}
        />
        {erro && <div className="login-erro">{erro}</div>}
        <label>
          <span className="rotulo">E-mail</span>
          <input
            className="campo-texto" type="email" autoFocus autoComplete="username"
            value={email} onChange={(e) => setEmail(e.target.value)} required
          />
        </label>
        <label>
          <span className="rotulo">Senha</span>
          <input
            className="campo-texto" type="password" autoComplete="current-password"
            value={senha} onChange={(e) => setSenha(e.target.value)} required
          />
        </label>
        <button className="bt" type="submit" disabled={ocupado} style={{ width: "100%", justifyContent: "center" }}>
          {ocupado ? "Entrando…" : "Entrar"}
        </button>
      </form>
    </div>
  );
}
